import React from 'react';
import SummaryPanel from 'components/common/SummaryPanel';
import { IPurchaseOrdersSummaryPanel } from './SummaryPanel.properties';
import SummaryTableSchema from '../SummaryPanel/SummaryTableSchema';
import { useRetrievePurchaseOrdersSummary } from 'api/purchaseOrders/purchaseOrders';
import { usePOContextSelector, usePODispatch } from '../PurchaseOrders.context';
import { PurchaseOrdersActionTypes } from '../PurchaseOrders.actions';
import UpdateStatus from '../UpdateStatus/UpdateStatus';
import { withStyles } from '@material-ui/core';
import inlineStyles from './SummaryPanel.styles';

const PurchaseOrdersSummaryPanel = (_props: IPurchaseOrdersSummaryPanel) => {
    const { classes } = _props;
    const contextDispatch = usePODispatch();
    const fetchSummary = useRetrievePurchaseOrdersSummary(usePOContextSelector<'PurchaseOrder'>((state) => state.PurchaseOrder));

    React.useEffect(
        () => {
            if (fetchSummary?.data && fetchSummary?.data?.PurchaseOrderSummary !== null) {
                contextDispatch({
                    [PurchaseOrdersActionTypes.setSummaryPanelData]: fetchSummary?.data?.PurchaseOrderSummary?.inlineObject,
                });
            }
        },
        [fetchSummary?.data]
    );

    return (
        <React.Fragment>
            <SummaryPanel
                loading={fetchSummary.isInitialLoading}
                data={fetchSummary.data?.PurchaseOrderSummary?.inlineObject}
                schema={SummaryTableSchema}
                customChildren={{ UpdateStatus }}
                customClassNames={classes.poSummary}
            />
        </React.Fragment>
    );
};

export default withStyles(inlineStyles, { index: 1 })(PurchaseOrdersSummaryPanel);
